// ============================================================
// bcBilling.js — Business Central billing (ruled 2026-10-21/22). A2Z admin
// only; the backend is functions/admin-bc-billing.js.
// ============================================================
import { apiGet, apiPost } from './client';

const base = (clientId) => `/mgmt/admin/clients/${clientId}/bc`;

export const getBcBilling = (clientId) => apiGet(base(clientId));
export const searchLead = (clientId, email) => apiPost(`${base(clientId)}/lead-search`, email ? { email } : {});
export const linkLead = (clientId, leadId) => apiPost(`${base(clientId)}/lead-link`, { leadId });
export const skipLead = (clientId) => apiPost(`${base(clientId)}/lead-skip`, {});
export const convertToPaid = (clientId) => apiPost(`${base(clientId)}/convert`, {});
export const linkExistingCustomer = (clientId, customerNumber, confirm) => apiPost(`${base(clientId)}/link-customer`, { customerNumber, confirm: !!confirm });
export const billingOff = (clientId) => apiPost(`${base(clientId)}/billing-off`, {});
export const makeReadOnly = (clientId, body) => apiPost(`${base(clientId)}/read-only`, body);
export const restoreAccess = (clientId, sendEmail) => apiPost(`${base(clientId)}/restore-access`, { sendEmail: !!sendEmail });
export const creditCharge = (clientId, chargeId, body) => apiPost(`${base(clientId)}/charges/${chargeId}/credit`, body);
export const retryCharge = (clientId, chargeId) => apiPost(`${base(clientId)}/charges/${chargeId}/retry`, {});
export const runMonthEnd = (clientId, period, send) => apiPost(`${base(clientId)}/run-month-end`, { period, send: !!send });
export const getBcStates = () => apiGet('/mgmt/admin/billing/bc-states');

export const STATE_LABELS = Object.freeze({
  trial: 'Trial',
  converted: 'Converted (waiting for the mandate)',
  billing_on: 'Billing on',
  billing_off: 'Billing off',
});
